/* Events page: countdown on the next event, .ics download, and hiding past events when the page comes from a cache. */
(() => {
  const root = document.querySelector('[data-ht-events]');
  if (!root) return;
  const lang = (document.documentElement.lang || 'hu').slice(0, 2);
  const T = lang === 'en'
    ? { today: 'today', tomorrow: 'tomorrow', days: (n) => `in ${n} days` }
    : { today: 'ma', tomorrow: 'holnap', days: (n) => `${n} nap múlva` };
  const day0 = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; };
  const today = day0(new Date());
  const evs = [...root.querySelectorAll('[data-ht-ev]')];
  evs.forEach((ev) => {
    const d = day0(ev.dataset.date + 'T12:00:00');
    if (d < today) ev.hidden = true;   // cached page after the event day
  });
  const next = evs.find((ev) => !ev.hidden && !ev.classList.contains('is-canceled'));
  evs.forEach((ev) => ev.classList.toggle('ht-ev--next', ev === next));
  const cd = next && next.querySelector('[data-ht-ev-countdown]');
  if (cd) {
    const n = Math.round((day0(next.dataset.date + 'T12:00:00') - today) / 86400000);
    cd.textContent = '· ' + (n <= 0 ? T.today : n === 1 ? T.tomorrow : T.days(n));
  }
  // .ics for Apple / Outlook calendars (Google gets a direct link)
  const pad = (s) => (s || '').replace(':', '') + '00';
  const esc = (s) => (s || '').replace(/[\\,;]/g, (c) => '\\' + c).replace(/\n/g, '\\n');
  root.addEventListener('click', (e) => {
    const b = e.target.closest('[data-ht-ev-ics]');
    if (!b) return;
    const ev = b.closest('[data-ht-ev]');
    const ymd = ev.dataset.date.replace(/-/g, '');
    const from = ev.dataset.from ? pad(ev.dataset.from) : '100000';
    const to = ev.dataset.to ? pad(ev.dataset.to) : '180000';
    const stamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d+/, '');
    const ics = [
      'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Hound Theory//Events//HU', 'CALSCALE:GREGORIAN',
      // the zone the times refer to, spelled out for strict clients (some Outlook versions ignore a bare TZID)
      'BEGIN:VTIMEZONE', 'TZID:Europe/Budapest',
      'BEGIN:DAYLIGHT', 'TZOFFSETFROM:+0100', 'TZOFFSETTO:+0200', 'TZNAME:CEST', 'DTSTART:19700329T020000', 'RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU', 'END:DAYLIGHT',
      'BEGIN:STANDARD', 'TZOFFSETFROM:+0200', 'TZOFFSETTO:+0100', 'TZNAME:CET', 'DTSTART:19701025T030000', 'RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU', 'END:STANDARD',
      'END:VTIMEZONE',
      'BEGIN:VEVENT',
      `UID:${ymd}-${from}-${esc(ev.dataset.title).length}@houndtheory.com`, `DTSTAMP:${stamp}`,
      `DTSTART;TZID=Europe/Budapest:${ymd}T${from}`, `DTEND;TZID=Europe/Budapest:${ymd}T${to}`,
      `SUMMARY:${esc(ev.dataset.title)}`, `LOCATION:${esc(ev.dataset.location)}`, `URL:${ev.dataset.url}`,
      'END:VEVENT', 'END:VCALENDAR',
    ].join('\r\n');
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([ics], { type: 'text/calendar;charset=utf-8' }));
    a.download = `hound-theory-${ymd}.ics`;
    document.body.append(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(a.href), 4000);
    b.closest('details').open = false;
  });
  // close the calendar menu when clicking elsewhere, or with Esc (focus goes back to its button)
  document.addEventListener('click', (e) => {
    root.querySelectorAll('.ht-ev__cal[open]').forEach((d) => { if (!d.contains(e.target)) d.open = false; });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    root.querySelectorAll('.ht-ev__cal[open]').forEach((d) => { d.open = false; d.querySelector('summary').focus({ preventScroll: true }); });
  });
  // keep the open menu on screen: right-align it to its button when it would run off the right edge (phones)
  root.addEventListener('toggle', (e) => {
    const d = e.target;
    if (!d.matches || !d.matches('.ht-ev__cal') || !d.open) return;
    const m = d.querySelector('.ht-ev__calmenu');
    m.classList.remove('is-end');
    if (d.getBoundingClientRect().left + m.offsetWidth > document.documentElement.clientWidth - 8) m.classList.add('is-end');   // offsetWidth: not the popping scale
  }, true);
})();
